import {mapGetters} from "vuex";

export default {
	props: ['showActiveWatchlistCheck'],
	computed: {
		...mapGetters(['watchlist', 'watchlistLogIds']),
		onActiveList() {
			return this.watchlist && this.watchlist.items && this.watchlistLogIds.includes(this.logId);
		},
		watchIcon() {
			return this.showActiveWatchlistCheck && this.watchlist && this.onActiveList ? 'star' : 'star_border';
		}
	}
}